/**
 * Dealer Network AdminService API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
 /* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent }                           from '@angular/common/http';
import { CustomHttpUrlEncodingCodec }                        from '../encoder';

import { Observable }                                        from 'rxjs';


import { TableConfigurationDto } from '../model/tableConfigurationDto';
import { VPError } from '../model/vPError';

import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';


@Injectable()
export class TableConfigurationViewService {

    protected basePath = '/';
    protected defaultHeaders = new HttpHeaders();
    protected configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional()@Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * 
     * Lazy check AmsAction:GET/api/TableConfigurationView/{tableName}/business/{businessId} AmsResource:{country}/{business}/_* 
     * @param tableName 
     * @param businessId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getBusinessTableConfiguration(tableName: string, businessId: string, observe?: 'body', reportProgress?: boolean): Observable<TableConfigurationDto>;
    public getBusinessTableConfiguration(tableName: string, businessId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableConfigurationDto>>;
    public getBusinessTableConfiguration(tableName: string, businessId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableConfigurationDto>>;
    public getBusinessTableConfiguration(tableName: string, businessId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling getBusinessTableConfiguration.');
        }

        if (businessId === null || businessId === undefined) {
            throw new Error('Required parameter businessId was null or undefined when calling getBusinessTableConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TableConfigurationDto>(`${this.basePath}/api/TableConfigurationView/${encodeURIComponent(String(tableName))}/business/${encodeURIComponent(String(businessId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * Lazy check AmsAction:GET/api/TableConfigurationView/{tableName}/country/{countryId} AmsResource:{country}/_* 
     * @param tableName 
     * @param countryId 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getCountryTableConfiguration(tableName: string, countryId: string, observe?: 'body', reportProgress?: boolean): Observable<TableConfigurationDto>;
    public getCountryTableConfiguration(tableName: string, countryId: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableConfigurationDto>>;
    public getCountryTableConfiguration(tableName: string, countryId: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableConfigurationDto>>;
    public getCountryTableConfiguration(tableName: string, countryId: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling getCountryTableConfiguration.');
        }

        if (countryId === null || countryId === undefined) {
            throw new Error('Required parameter countryId was null or undefined when calling getCountryTableConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TableConfigurationDto>(`${this.basePath}/api/TableConfigurationView/${encodeURIComponent(String(tableName))}/country/${encodeURIComponent(String(countryId))}`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * 
     * AmsAction:GET/api/TableConfigurationView/{tableName}/user AmsResource:{country}/{business}/tableConfiguration/{tableName} 
     * @param tableName 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getUserTableConfiguration(tableName: string, observe?: 'body', reportProgress?: boolean): Observable<TableConfigurationDto>;
    public getUserTableConfiguration(tableName: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<TableConfigurationDto>>;
    public getUserTableConfiguration(tableName: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<TableConfigurationDto>>;
    public getUserTableConfiguration(tableName: string, observe: any = 'body', reportProgress: boolean = false ): Observable<any> {

        if (tableName === null || tableName === undefined) {
            throw new Error('Required parameter tableName was null or undefined when calling getUserTableConfiguration.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'text/plain',
            'application/json',
            'text/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        return this.httpClient.get<TableConfigurationDto>(`${this.basePath}/api/TableConfigurationView/${encodeURIComponent(String(tableName))}/user`,
            {
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

}
